import { createContext } from 'react';

/**
 * @typedef {Object} Role
 * @property {string} Description
 * @property {string} Full
 * @property {number} ID
 * @property {string} search
 * @property {string} Short
 */

/**
 * @typedef {Object} Privilege
 * @property {string} Description
 * @property {string} Full
 * @property {number} ID
 * @property {string} search
 * @property {string} Short
 */

/**
 * @typedef {Object} User
 * @property {string} AccountType
 * @property {number} AccountTypeID
 * @property {string} Department
 * @property {string} ESOID
 * @property {string} Email
 * @property {string} FamiliarESOID
 * @property {number} ID
 * @property {string} JobTitle
 * @property {string} Manager
 * @property {string} Name
 * @property {string} NetworkID
 * @property {boolean} Primary
 * @property {string} PublicESOID
 * @property {?string} RetireDate
 * @property {Role[]} Roles
 * @property {Privilege[]} Privileges
 * @property {string} UPN
 * @property {boolean} isDEVTeam
 * @property {boolean} IsSiteAdministrator
 * @property {string} SiteAdministratorType
 * @property {boolean} IsEmployee
 * @property {boolean} IsNonEmployee
 */

/**
 * @typedef {Object} UserInfo
 * @property {boolean} allowImpersonation
 * @property {User} userProfile
 * @property {?User} impersonationProfile
 */

/**
 * @typedef {Object} ContextUser
 * @property {UserInfo} userInfo
 * @property {function} setUserInfo
 */

/**
 * @type ContextUser
 */
const UserContext = createContext(null);

export { UserContext };
